import LinkText from '@components/Atoms/Link';
import FormButtonNew from '@components/FormButtonNew/FormButtonNew';
import LabelCheckbox from '@components/Molecules/LabelCheckbox';
import LabelInput from '@components/Molecules/LabelInput';
import { LabelPositions } from '@enums/LabelPositions';
import { emailValidation, getEmailInputValue } from '@helpers/validation.helper';
import useInput from '@hooks/useInput';
import { CircularProgress } from '@mui/material';
import React, { useState } from 'react';
import styles from './index.module.scss';

const RegistrationForm: React.FunctionComponent<RegistrationFormProps> = (props) => {
  const { onClick, isUserCreating } = props;
  const [isAgree, setIsAgree] = useState(false);
  let isFormValid = false;

  const {
    value: emailValue,
    isValid: emailIsValid,
    hasError: emailHasError,
    valueChangeHandler: emailChangeHandler,
    inputBlurHandler: emailBlurHandler,
    reset: emailReset,
  } = useInput(emailValidation, getEmailInputValue, '');

  const handleTermsAndConditions = () => {
    setIsAgree((preState) => !preState);
  };

  if (emailIsValid && isAgree) {
    isFormValid = true;
  }

  const handleCreateUser = async (event: React.FormEvent<HTMLElement>) => {
    event.preventDefault();
    if (isFormValid) {
      onClick(emailValue, isAgree);
    }

    emailReset();
    setIsAgree(false);
  };

  const termsAndConditionsLabel = (
    <>
      I agree to Hapstar’s{' '}
      <LinkText path="/policies/terms/" target="_blank" rel="noopener noreferrer">
        Terms & Conditions
      </LinkText>{' '}
      and{' '}
      <LinkText path="/policies/privacy/" target="_blank" rel="noopener noreferrer">
        Privacy Policy
      </LinkText>
    </>
  );

  return (
    <form onSubmit={handleCreateUser}>
      <div className={styles.inputHolder}>
        <LabelInput
          id="email"
          label="Email *"
          type="text"
          name="email"
          placeholder="Add your email here..."
          onChange={emailChangeHandler}
          onBlur={emailBlurHandler}
          value={emailValue || ''}
          isError={emailHasError}
        />
        {emailHasError && <p className={styles.hsError}>Please enter a valid email address</p>}
      </div>
      <div className={styles.inputHolderRememberMe}>
        <LabelCheckbox
          id="termsAndConditions"
          name="termsAndConditions"
          onChange={handleTermsAndConditions}
          checked={isAgree}
          labelPosition={LabelPositions.right}
          label={termsAndConditionsLabel}
        />
      </div>
      <div className={styles.buttonHolder}>
        <FormButtonNew
          onClick={handleCreateUser}
          disabled={!isFormValid || isUserCreating}
          color="primary"
          type="submit"
        >
          {isUserCreating ? (
            <>
              <CircularProgress color="inherit" size={20} />
              &nbsp;Creating user...
            </>
          ) : (
            'Continue'
          )}
        </FormButtonNew>
      </div>
    </form>
  );
};

RegistrationForm.displayName = 'RegistrationForm';

interface RegistrationFormProps {
  onClick: (emailValue: string, isAgreeValue: boolean) => void;
  isUserCreating: boolean;
}

export default RegistrationForm;
